import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import premiumIcon from "../../assets/icons/premium.svg";

interface UpgradeDialogProps {
  upgradeDialogOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const UpgradeDialog: React.FC<UpgradeDialogProps> = ({
  upgradeDialogOpen,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog open={upgradeDialogOpen} onClose={onClose}>
      <DialogTitle style={{ textAlign: "center" }}>
        <Typography variant="h5">Upgrade Your Account</Typography>
      </DialogTitle>
      <DialogContent>
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          mt="1rem"
          mb="8px"
        >
          <img src={premiumIcon} alt="" style={{ width: "80px" }} />
        </Box>
        <Typography maxWidth={600} fontSize={18}>
          In order to access this feature, you need to upgrade your account to a
          premium plan. <strong>Upgrade now</strong> to unlock premium features.
        </Typography>
      </DialogContent>
      <DialogActions style={{ padding: "20px 24px" }}>
        <Button onClick={onClose} className="mr-1">
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Upgrade
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpgradeDialog;
